import React from 'react';
import style from './FsBuildTop.module.css';
import ReactDOM from 'react-dom';
import { Button } from '@jd/find-react';

 

import KeeVue from '../base/KeeVue.js'

 

import $ from 'jquery';




 export default class FsBuildTopReport extends KeeVue {
   constructor(props) {
          super(props);

		 // this.showHelpInfo = this.showHelpInfo.bind(this);
		  // this.myRef = React.createRef();
		  let that= this;




 			this.state =  {
 				randId: this.getRandString(),
 				isKeeShowBorder: false,
 				showSource: false,
 				configWindow: null,
 				appId: window.appId,
 				jdccApp: {title:'','name':''},
 				currentScale:"100%",
				saveBtnDisable:true,
				shoujiBtnDisable:false,
				clientConfig:{},
				mainInfo:{
					sys:{
						
					}
				},
				beginType:true
 			};

 }

 componentDidMount(){
 			let that = this;
			// setTimeout(function(){
			// 			  that.bindThis(that);
			// },10);

			this.registComponent();
 
 			if(  this.isNotBlank(this.state.appId)) {
 				this.doRequest("/jdccApp/get?id=" + this.state.appId, (jdccApp)=> {

					 console.log(JSON.stringify(jdccApp),'jdccApp');
					 
					 this.jdccApp = jdccApp;
					 
					 this.doRequest("/reportTemplate/getByAppcode?appCode="+jdccApp.name,(report)=>{
					 	 console.log(report,'report')
						this.reportStatus = report.reportStatus;
					 	if(report.reportStatus=="3")
					 	{
					 		this.state.saveBtnDisable = true;
					 	}
						else
						{
							this.state.saveBtnDisable = false;
						}
						
						if(report.reportStatus=="2"|| report.state=='TEMP')
						{
							this.state.shoujiBtnDisable = true;
						}
						else
						{
							this.state.shoujiBtnDisable = false;
						}
						
						
						
						this.refresh();
					 })
					 
					 

					 that.setState({
					 	jdccApp:jdccApp
					 });
					 
					 
					// that.render();
 				});
				
				// let url = window.location.protocol+"//"+window.location.host+"/clientConfig/getMap";
				
				let pathName = window.location.pathname.replace("//","/");
				
				pathName = pathName.substring(0,pathName.lastIndexOf("/"));
				
				 let url = window.location.protocol+"//"+(window.location.host+pathName+"/clientConfig/getMap");
				 if(process.env.NODE_ENV=='development')
				 {
				 			 window.rootUri=window.webUrl;
				 			 url = window.webUrl+"/clientConfig/getMap";
				 }
				 
				this.doRequest(url,(ret)=>{
				 
					this.state.clientConfig = ret;
					this.doRequest("/mainFrame/getMainInfo",(mainInfo)=>{
						if(mainInfo.success)
						{
							 
							 
							this.state.mainInfo = mainInfo.retData;
							this.refresh();
						}
					});
				});	
					
					
				
 			}

this.onEvent("saveFinish",()=>{
	 
	this.state.saveBtnDisable = false;

	 
	 
	this.refresh();
})
 			this.onEvent("key.format", this.formatJavascript);
 			this.onEvent("key.q", this.viewChange);
 			this.onEvent("currentScaleValue",(ret)=>{
 				this.state.currentScale = ret+"%";
				this.refresh()
 			})
 			this.onEvent("pageSaved",()=>{
				
				this.state.shoujiBtnDisable = true;
				
				this.doRequest("/reportTemplate/getByAppcode?appCode="+this.jdccApp.name,(report)=>{
					 
										this.reportStatus = report.reportStatus;
				 
										
										if(report.reportStatus=="2"|| report.state=='TEMP')
										{
											this.state.shoujiBtnDisable = true;
										}
										else
										{
											this.state.shoujiBtnDisable = false;
										}
										
										
										
										this.refresh();
				})
				 
 				this.doRequest("/jdccApp/get?id=" + that.state.appId, function(jdccApp) {
 					that.state.jdccApp = jdccApp;
					this.refresh();
 				})
 			})
 		}

 			viewChange=()=> {
 				this.controller.showSource = !this.controller.showSource;
 				window.editor.setValue(this.keePage.vueSource);
 				window.editor.clearSelection();
 			}
 			openTemplateDlg=()=> {
 			}
 			zoomOut=()=>
 			{
				this.props.controller.showCenterPage = "huabu";
 				this.sendEvent("zoomOut");
 			}
 			zoomIn=()=>
 			{
				this.props.controller.showCenterPage = "huabu";
 				this.sendEvent("zoomIn");
 			}
 			copyComponent=()=> {
 				this.sendEvent("copyComponent")
 			}
 			cutComponent=()=> {
 				this.sendEvent("cutComponent")
 			}
 			pasteComponent=()=> {
 				this.sendEvent("pasteComponent")
 			}
 			testDebug=()=> {
 			}
 			showKeeBorder=(e)=> {
				
				this.props.controller.showCenterPage = "huabu";
				
				e.target.blur();
 				 
				this.state.isKeeShowBorder = !this.state.isKeeShowBorder;
								window.quanjuShowBorder= this.state.isKeeShowBorder
								this.showKeeBorderState(this.props.components, this.state.isKeeShowBorder);
								this.sendEvent("changeShowBorder",this.state.isKeeShowBorder);
								this.refresh()
								
 			}
 			showKeeBorderState=(componentArray, state)=> {
 				if(componentArray != null) {
 					for(let i = 0; i < componentArray.length; i++) {
 						componentArray[i].isKeeShowBorder = state;
 						this.showKeeBorderState(componentArray[i].child, state);
 					}
 				}
 			}
 			formatJavascript=()=> {
				this.props.controller.showCenterPage = "source";
 				let js_source = window.editor.getValue();
 				let fjs = window.js_beautify(js_source, 1, "\t");
 				window.editor.setValue(fjs);
 				window.editor.clearSelection();
 			}
			
			
			
 			previewComponent=()=> {
				
				// 先把数据存入到
				
				// 因为是报表模式，直接使用报表模式预览
				
			   // let url = "/index.html?sp=2021_M::jzbForm/show&appCode="+this.state.jdccApp.name+"&fullPage=1";
				
				// this.state.configWindow = window.open( url, this.state.jdccApp.title + "预览");
					
				
 			// 	if(this.state.jdccApp.clientType=="APPSITE")
 			// 	{
 			// 		let previewUrl = (window.webUrl+"/appShow/"+this.state.jdccApp.name+"/"+this.keePage.code+"?previewUrl="+window.webUrl+"&tid="+window.tid);
 			// 		this.openDlgPage("M::jdccApp/showPreviewBarcode"  , {
 			// 		title: '扫码预览',
 			// 		size: 'normal',
 			// 		width: '45%',
 			// 		top: "10vh",
 			// 		loadUrl: '/jdccApp/get?id=' ,
 			// 		previewUrl:previewUrl,
 			// 		extraParas: {
 			// 		},
 			// 		onChanged(ret, form) {
 			// 			}
 			// 		})
 			// 	}
 			// 	else
 			// 	{
				
					this.sendEvent("top.preview",this.props.keePage.code);
					
				//	this.state.configWindow = window.open(("/index.html?tid=" + window.tid  + "&keyName="+window.keyName+"&pageCode=" + this.props.keePage.code+"&appName="+window.appName +"#preview"), window.appName + "预览");
					
				// }
 			}
 			showHelpInfo=()=> {
 				window.open(("http://cpaas.dev.xjoycity.com/front/help/index.jsp?tid="+window.tid), "系统帮助");
 
 			}
 			saveComponent=(evt)=> {
				this.state.saveBtnDisable = true;
				this.setState({shoujiBtnDisable:false})
				this.refresh();
 				this.sendEvent("top.save");
 			}
 			publishApp=()=> {
 				this.sendEvent("top.publishApp");
 			}
 			showComponentSource=()=>{
 				this.sendEvent("top.componentSource")
 			}
 			showComponentList=()=>{
 				this.openBottomPage("M::jdcc.vueComponent/list&id=",{});
 			}
 			showDataModelList=()=>{
 				this.openBottomPage("M::adminDbModel/tableList&id=",{});
 			}
			
			showComponentJsonPage=()=> { 
				this.props.controller.showCenterPage = "huabu";
				  this.sendEvent("showComponentJsonPage"); 
			}
			
			beginReport=()=>{
					let that = this;
						window.mainVueApp.$confirm('是否确定开启表单！', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning',
							callback: (action, instance) =>{
								if (action == "confirm") {
									this.doRequest("/reportTemplate/getByAppcode?appCode="+this.state.jdccApp.name,(report)=>{
										
										if(report&&report.id)
										{
											this.doRequest("/reportTemplate/updateReportStatus?id=" + report.id + "&reportStatus=2",
											 (ret)=> {
												//window.showMessage(ret);
												if(ret&&ret.success)
												{
													window.showMessage(ret);
													// this.state.shoujiBtnDisable = true;
													
													//alert(this.reportStatus );
													if(this.reportStatus=="1")
													{
														// 又来一个强依赖的需求；
														
															 
																this.openDlgPage("M::jzbAddForm/sharePage", {
																	appCode: this.state.jdccApp.name,
																	title: '分发',
																	className: 'dialog-custom',
																	size: 'normal',
																	onChanged: function(ret, form) { }
																})
													}
													
												}
												
												
												that.refresh();
											})
										}
									})
									
									this.setState({beginType:false,shoujiBtnDisable:false})
								}
								
							}
						});
			}
			

   render(){
   return(

 <div  style={{textAlign:'center'}} id={this.state.randId} >
     <div style={{float:' left',marginLeft:' 10px',marginTop:'0px'  }} >
         <div style={{ width:' 40px',lineHeight:' 54px',fontSize:' 30px',float:' left', textAlign:' center'}} >
            {
            	this.state.mainInfo.sys&&this.state.mainInfo.sys.logo?
            	<img src={this.state.clientConfig.fsUrl+this.state.mainInfo.sys.logo}
            	 
            	style={{height: '40px', margin: '3px'}} />
            	:
            	<img  
            	src = "http://deploy-sh.xjoycity.com/ic-file-server/api/fs/getById?ids=2021033111253214566032331960-CSY"
            	style={{height: '40px', margin: '3px'}} /> 
            }
         </div>
		 
		 
		 
         <div style={{ height:'40px',lineHeight:' 54px',fontSize:' 20px',fontWeight:'bold', 'float':' left', textAlign:' left',marginLeft:' 10px'}} >

 				{this.state.jdccApp!=null?this.state.jdccApp.title :'&nbsp;'}
				 
&nbsp; 
              
         </div>
     </div>
     <div className={`jdcc-disable-select`} style={{ float:' right',marginRight:' 0px', marginTop:' 0px',lineHeight:'50px'}} >
         
		 
		 
		  <Button type="primary"   ghost onClick={this.previewComponent} style={{margin:'0 8px'}}>
		        预览
		  </Button>
		  
		  <Button ref={(input) => {window.domTargets.saveBtn = input}}  type="primary"   ghost disabled={ this.state.saveBtnDisable}  style={{margin:'0 8px'}} onClick={this.saveComponent}>
		        保存
		  </Button>
		  <Button ref={(input) => {window.domTargets.shoujiBtn = input}}  type="primary"  disabled={ this.state.shoujiBtnDisable}  style={{margin:'0 8px'}}   onClick={this.beginReport}>
			{this.state.beginType?'开启收集':'分发'}
		  </Button>
        
        
     </div>
     <div style={{ float:' right',marginRight:' 50px', marginTop:' 0px',lineHeight:'50px'}} className={`jdcc-disable-select  top-btns`} >
         
		 <div className={`jdcc-disable-select  top-btns-center`} style={{marginTop:'-6px',height:'54px',overFlow:'hidden',display:'inline-block',marginLeft:'00px','float':'right'}} >
		     
			 <Button type="info"   onClick={()=>{window.pageType='full';this.sendEvent("changePageType","full");this.refresh();}} >
			     <div >
			         <i className={`fa fa-laptop`} style={{color:(window.pageType!='mobile'?'#2C68FF':'')}} >
			         </i>
			     </div>
			     
			 </Button>
			 <div style={{display:'inline-block',width:'2px', height:'40px'}}>
				<div className="shuxian1px" style={{float:'left',marginTop:'23px',width:'1px',marginLeft:'3px',height:'20px', background:'#cccc'}}></div>
			 </div>
			 <Button type="info"   onClick={()=>{window.pageType='mobile';this.sendEvent("changePageType","mobile");this.refresh();}} >
			     <div >
			         <i className={`iconfont icon-shouji`}  style={{color:(window.pageType=='mobile'?'#2C68FF':'')}}>
			         </i>
			     </div>
			      
			 </Button>
			 
		  
			  
			 
		 </div>
     </div>
    
 </div>
   );}
  }
